import React, { useContext, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { TextButton, Popover } from '@oneaudi/unified-web-components';
import { UeElement } from '@oneaudi/falcon-tools';
import { Context } from '../../../context/Context';
import { useTrackingManager } from '../../../utils/useTrackingManager';
import VtpButtons from './VtpButtons';
import { attachVerticalNavigation, getKeyboardFocusableElements } from '../../../utils/a11y';
import { useBreakpoint } from '../../../utils/useBreakpoint';

export const TriggerButton = styled(TextButton)`
  white-space: nowrap;
`;
interface VtpPopoverProps {
  disabled: boolean;
}

const VtpPopover: React.FC<VtpPopoverProps> = ({ disabled }) => {
  const { setPopOverState, isPopOverOpen, content } = useContext(Context);
  const { secondaryNavigation } = useTrackingManager();
  const { breakpoint } = useBreakpoint();

  const buttonText = content?.secondaryCta?.shopNowCta?.text;
  const targetRef = useRef(null);
  const popoverRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!popoverRef.current || !isPopOverOpen) return undefined;
    const cleanup = attachVerticalNavigation(popoverRef.current);

    return () => {
      cleanup();
    };
  }, [isPopOverOpen, popoverRef]);

  const handleKeyDown = (event: React.KeyboardEvent<HTMLButtonElement>) => {
    if (event.key === 'ArrowDown') {
      event.preventDefault();
      if (!isPopOverOpen) {
        setPopOverState(true);
        setTimeout(() => {
          if (!popoverRef.current) return;
          const ctas = getKeyboardFocusableElements(popoverRef.current);
          if (ctas.length > 0) {
            ctas[0].focus();
          }
        }, 0);
      }
    }
  };

  return (
    <Popover
      id="vtp-popover"
      role="group"
      withTip={false}
      alignment="right"
      open={isPopOverOpen}
      onClose={() => {
        setPopOverState(false);
      }}
      triggerElement={
        <TriggerButton
          data-testid="popover-trigger-button"
          variant="secondary"
          icon={isPopOverOpen ? 'arrow-up' : 'arrow-down'}
          iconPosition="trailing"
          size="sm"
          isFullWidth
          onClick={() => {
            setPopOverState(!isPopOverOpen);
            secondaryNavigation(!isPopOverOpen, breakpoint, buttonText);
          }}
          ref={targetRef}
          disabled={disabled}
          onKeyDown={(e) => {
            handleKeyDown(e);
          }}
          aria-haspopup="menu"
        >
          <UeElement
            type="text"
            property="secondaryCta_shopNowCta_text"
            label="Secondary CTA (optional) -  Fill in for VTP Secondary CTA (optional) - Label"
          >
            {buttonText}
          </UeElement>
        </TriggerButton>
      }
      content={
        <div ref={popoverRef}>
          <VtpButtons />
        </div>
      }
    />
  );
};

export default VtpPopover;
